// extracted by mini-css-extract-plugin
module.exports = {"Links":"ProfileSocialLinks_Links__Nzh_U"};